import React, { useEffect, useState } from 'react';

import CButton from '../../components/button/button';
import CInput from '../../components/input/input';
import { Line, Space } from '../../components/utils/utils';
import styles from './monitorizations.module.scss';

import '../../theme/global.scss';
import {
  IDataPaged,
  INewMonitorization,
  IRaport
} from '../../utils/interfaces/interfaces';
import CDropdown from '../../components/dropdown/dropdown';
import {
  addMonitorization,
  updateMonitorization
} from '../../network/monitorization';
import { notify } from '../../notifications/notification';
import { formatDate } from '../../utils/strings';

import { getAll } from '../../network/raports';
import { measuresTypes } from '../../types/measures';
import { useGetCurrentUserQuery } from '../../api';

const initialState: INewMonitorization = {
  number: '',
  name: '',
  uniqueFileNumber: '',
  date: new Date(),
  ccrReportId: 0,
  type: measuresTypes.MEASURES
};

interface IAddMonitorization {
  id?: number;
  monitorization?: any;
  edit?: boolean;
  callback: any;
}

const AddMonitorization = (props: IAddMonitorization) => {
  const [form, updateForm] = useState(initialState);
  const [savedInfo, setSavedInfo] = useState(false);
  const [raports, setRaports] = useState({} as IDataPaged);

  const getInitialRaports = () =>
    getAll().then(({ data }) => {
      setRaports(data);
    });

  useEffect(() => {
    if (props.monitorization) {
      updateForm({
        ...props.monitorization,
        date: new Date(props.monitorization.date),
        ccrReportId: props.monitorization.ccrReport.id
      });
    }
  }, [props.monitorization]);

  useEffect(() => {
    getInitialRaports();
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    updateForm(form => ({ ...form, [name]: value }));
  };

  const handleSelect = (item: IRaport) => {
    item && updateForm(form => ({ ...form, ccrReportId: item.id }));
  };

  const handleDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    new Date(value) && updateForm(form => ({ ...form, date: new Date(value) }));
  };

  const handleSubmitDecision = (event: React.MouseEvent) => {
    /* prevent from reloading */
    event.preventDefault();

    /* submit request for decision */
    if (form.name && form.date && form.ccrReportId && form.number) {
      if (!props.edit) {
        addMonitorization(form).then(() => {
          notify('Ati adaugat o monitorizare', 'success');
          setSavedInfo(true);
          props.callback();
          // setID(data.id);
        });
      } else {
        if (props.id) {
          updateMonitorization({ ...form, id: props.id }).then(() => {
            notify('Ati editat cu succes monitorizarea', 'success');
            setSavedInfo(true);
            props.callback();
            // setID(data.id);
          });
        }
      }
    } else {
      notify('Lipsesc informatii', 'warning');
    }
    /* submit request for  measures */
  };

  const { data: user } = useGetCurrentUserQuery();

  return (
    <form className={styles.addDecision}>
      <p className='body-dark bold'>
        {props.edit ? 'Editare monitorizare' : 'Monitorizare nouă'}
      </p>
      <Line width='100px' />

      <Space vertical={'30px'} />

      <CInput
        label='Număr document'
        type='text'
        id='number'
        placeholder='Numărul documentului'
        name='number'
        value={form.number}
        onChange={handleChange}
        required
        disabled={savedInfo}
      />
      <Space horizontal={'10vw'} />
      <CInput
        label='Nume document'
        type='text'
        id='name'
        placeholder='Numele documentului'
        name='name'
        value={form.name}
        onChange={handleChange}
        required
        disabled={savedInfo}
      />

      <CDropdown
        label={!user?.institution.private ? 'Raport' : 'Raport / contract'}
        visiblePhrase={(item: IRaport) => item.name}
        list={raports.data}
        placeholder='Alegeți un raport de control inițial'
        onChange={handleSelect}
        disabled={savedInfo}
        currentOption={props.id ? props.monitorization.ccrReport : null}
      />
      <Space horizontal={'10vw'} />
      <CInput
        label='Dată'
        type='date'
        id='date'
        placeholder='zz.ll.aaaa'
        name='data'
        value={formatDate(form.date)}
        onChange={handleDate}
        required
        disabled={savedInfo}
      />

      <CInput
        label='Adaugă măsuri'
        type='radio'
        id='measures'
        name='type'
        value={form.type}
        checked={form.type === measuresTypes.MEASURES}
        onChange={e => {
          updateForm(form => ({ ...form, type: measuresTypes.MEASURES }));
        }}
      />

      <CInput
        label='Adaugă recomandări'
        type='radio'
        id='recomandations'
        name='type'
        checked={form.type === measuresTypes.RECOMANDATIONS}
        onChange={() =>
          updateForm(form => ({ ...form, type: measuresTypes.RECOMANDATIONS }))
        }
      />
      <Space vertical={'30px'} />
      <CButton
        label='Salvează'
        type='submit'
        className={styles.submit}
        onClick={handleSubmitDecision}
      />
    </form>
  );
};

export default AddMonitorization;
